import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
      user: false,
      loginUserName:'',
    },
    actions : {
      changeLoginUserName (ctx,name) {
        // ctx：上下文对象
        ctx.commit('changeLoginUserName',name); //调用mutations的方法来修改name
      }
    },
    mutations: {
        // 登录
        login(state, user) {
            state.user = user;
            localStorage.setItem("userInfo", user);
        },
        // 退出
        logout(state, user) {
            state.user = "";
            localStorage.setItem("userInfo", "");
        },
        changeLoginUserName (state,name) {
          state.loginUserName = name; //改变state中name的值
        }
    }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js